import React from "react";

const ContactForm = () => {
  return (
    <div className="flex min-h-screen items-center justify-center dark:bg-slate-600">
      <div className="body-font relative w-full max-w-4xl text-gray-600 dark:text-slate-200">
        <div className="section--spacing-x section--spacing-y grid grid-cols-1 justify-center gap-12 align-middle md:grid-cols-2">
          <div className="flex w-full flex-col dark:bg-slate-600 md:col-span-2 md:mx-auto md:max-w-2xl">
            <h2 className="title-font mb-1 text-center text-3xl font-light text-secondary dark:text-slate-200">
              CONTACT US
            </h2>
            <p className="mb-5 text-center leading-relaxed text-gray-600 dark:text-slate-200">
              Get Our 24/7 support
            </p>
            <div className="relative mb-4">
              <label
                htmlFor="name"
                className="text-sm leading-7 text-gray-600 dark:text-slate-200"
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                className="w-full rounded border border-gray-300 bg-white px-3 py-1 text-base leading-8 text-gray-700 outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
              />
            </div>
            <div className="relative mb-4">
              <label
                htmlFor="email"
                className="text-sm leading-7 text-gray-600 dark:text-slate-200"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                className="w-full rounded border border-gray-300 bg-white px-3 py-1 text-base leading-8 text-gray-700 outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
              />
            </div>
            <div className="relative mb-4">
              <label
                htmlFor="message"
                className="text-sm leading-7 text-gray-600 dark:text-slate-200"
              >
                Message
              </label>
              <textarea
                id="message"
                name="message"
                className="h-32 w-full resize-none rounded border border-gray-300 bg-white px-3 py-1 text-base leading-6 text-gray-700 outline-none transition-colors duration-200 ease-in-out focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200"
              ></textarea>
            </div>
            <button className="w-full rounded border-0 bg-stone-500 px-6 py-2 text-lg font-light text-white duration-300 hover:bg-indigo-600 focus:outline-none dark:bg-slate-500 dark:hover:bg-slate-700 md:mx-auto md:w-auto">
              SUBMIT
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
